import React from 'react';
import * as S from './StartNow.styles';

const StartNow = props => {
  const scrollTop = () => {
    window.scrollTo({top: 0, behaviour: 'auto'});
  };
  const {lob = ''} = props;
  const subText = lob && lob?.toLowerCase() === 'hotel' ? 'Hotel Booking' : 'Flight Booking';
  return (
    <S.StartNowMainWrap>
      <S.RoundedBack />
      <S.StartNowInnerWrap>
        <S.StartNowWrap>
          <S.StartNowTextWrap>
            <S.StartNowText>{`Start a Profitable Business Today with the`}</S.StartNowText>
            <S.StartNowHeadText>
              {`Best B2B ${lob ? subText : ''} Travel Portal in India!`}
            </S.StartNowHeadText>
            <S.StartNowSubText>It is a feature loaded platform!</S.StartNowSubText>
          </S.StartNowTextWrap>
          <S.StartNowButtonWrap>
            <S.StartNowButton onClick={scrollTop}>Sign up now</S.StartNowButton>
          </S.StartNowButtonWrap>
        </S.StartNowWrap>
      </S.StartNowInnerWrap>
    </S.StartNowMainWrap>
  );
};

export default StartNow;
